<script setup lang="ts">
import { ref, onMounted } from 'vue'
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import carteService, { type Carte } from '@/services/carteService'

const selectedCarte = ref<Carte | null>(null)

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/ma-carte',
    icon: '/public/icons/icon-carte.svg',
    label: 'Ma carte',
    exact: true,
    initialSidebarOpen: false
  },
  {
    to: '/front/ma-carte/transactions',
    icon: '/public/icons/icon-transaction.svg',
    label: 'Transactions',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/repartition',
    icon: '/public/icons/icon-souscription.svg',
    label: 'Répartition',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/parametres',
    icon: '/public/icons/icon-verrouillage.svg',
    label: 'Paramètres',
    initialSidebarOpen: true
  }
]

onMounted(async () => {
  try {
    const res = await carteService.getCartes()
    if (res.data && Array.isArray(res.data) && res.data.length > 0) {
      selectedCarte.value = res.data.find((c: Carte) => c.parDefaut) || res.data[0]
    }
  } catch (e) {
    // silencieux
  }
})
</script>

<template>
  <SectionSidebar :menu-items="menuItems">
    <template #widget>
      <div class="sidebar-top px-3" v-if="selectedCarte">
        <div class="widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6">
          <div class="flex align-items-center gap-4 mb-3">
            <img src="/public/icons/icon-carte.svg" class="size-base icon-neutral" alt="" />
            <h4 class="secondary-font">Ma Carte</h4>
            <span v-if="selectedCarte.statut === 'active'" class="tag-state success ml-4">Active</span>
            <span v-else class="tag-state ml-4">{{ selectedCarte.statut }}</span>
          </div>
          <h6 class="secondary-font text-primary-color mb-4">
            {{ selectedCarte.alias || selectedCarte.type || 'Carte' }}
          </h6>
          <h2 class="secondary-font">
            {{ selectedCarte.numeroMasque || '' }}
          </h2>
        </div>
      </div>
    </template>
  </SectionSidebar>

  <section class="app-section">
    <div class="page-space-25" />
    <router-view />
  </section>
</template>
